import { DefaultUrlSerializer, UrlTree, UrlSerializer } from '@angular/router';

export class CustomUrlSerializer implements UrlSerializer {
	public parse(url: string): UrlTree {
		const defaultUrlSerializer = new DefaultUrlSerializer();
		const splittedUrl = url.replace(/%3D/g, '=').split(/(;[\w\d-]*=[\w\d-]*)/g);

		const matrixParams = this.extractMatrixParams(splittedUrl);
		const queryParams = this.extractQueryParams(url);

		const newUrl = this.buildNewString(splittedUrl, matrixParams, queryParams);
		return defaultUrlSerializer.parse(newUrl);
	}

	public serialize(tree: UrlTree): string {
		const defaultUrlSerializer = new DefaultUrlSerializer(),
			path = defaultUrlSerializer.serialize(tree);
		return path.replace(/%3D/g, '=');
	}

	private extractMatrixParams(splittedUrl: string[]): string {
		return splittedUrl
			.filter(param => param.startsWith(';'))
			.reduce((previous, current) => ((previous = previous + current.substr(1) + '&'), previous), '')
			.slice(0, -1);
	}

	private extractQueryParams(url: string): string {
		return url.lastIndexOf('?') > -1 ? url.substr(url.lastIndexOf('?') + 1, url.length - 1) : '';
	}

	private buildNewString(splittedUrl: string[], matrixParams: string, queryParams: string): string {
		let newUrl = splittedUrl.reduce((previous, current) => {
			if (current && !current.startsWith(';')) {
				if (current.indexOf('?')) {
					previous = previous + current.split('?')[0];
				} else {
					previous = previous + current;
				}
			}
			return previous;
		}, '');

		if (matrixParams || queryParams) {
			newUrl = newUrl + '?';
		}
		if (matrixParams) {
			newUrl = newUrl + matrixParams;
		}
		if (queryParams) {
			newUrl = newUrl + (matrixParams ? '&' : '') + queryParams;
		}

		return newUrl;
	}
}
